// extracted by mini-css-extract-plugin
export default {"downloadButton":"styles_downloadButton__4mGWH","a":"styles_a__un6Sa"};